var PnKPreferences = function () {
  const PREFERENCE_GREETINGS_SELECTOR = 'taste-profile-greetings';
  const PREFERENCE_BASICS_SELECTOR = 'taste-profile-basics';
  const PREFERENCE_BASICS_VALUE_SELECTOR = 'taste-profile-basics-value';
  const PREFERENCE_ROOT_SELECTOR = 'preference-products';
  const PREFERENCE_LIST_SELECTOR = 'product-card-list';
  const PREFERENCE_CARD_TEMPLATE_SELECTOR = 'product-card-preference-template';
  const PREFERENCE_CARD_IMAGE_WRAPPER_SELECTOR = 'product-card-image-wrapper';
  const PREFERENCE_CARD_PRICE_SELECTOR = 'product-card-price';
  const PREFERENCE_CARD_MATCH_SELECTOR = 'product-card-preference-match';
  const PREFERENCE_CARD_REASON_SELECTOR = 'product-card-preference-reason';
  const PREFERENCE_CARD_AROMA_SELECTOR = 'product-card-aroma';


  const VERBOSE = false;
  const UNREGISTERED_USER_CARDS_LIMIT = 80; // 0 - for all
  const LANDING_MIN_CARDS = 4; // 0 - for all
  const LANDING_MIN_MATCHING_SCORE = 60;
  const FIRST_UNLAZY_IMAGES_COUNT = 8;

  const unionMatchingFilterGroups = {
    type: ['white', 'red', 'rosé', 'sparkling', 'sweet and fortified']
  };

  const fallbackOptions = {
      "Price": {
          "filterOptionId": "pf_p_price",
          "manualValues": [
              ":100",
              "100:200",
              "200:300",
              "300:400",
              "400:500",
              "500:"
          ]
      },
      "Sparkling": {
          "filterOptionId": "pf_t_sparkling",
          "prefix": "primary\\:\\:sparkling\\:\\:",
          "manualValues": [
              "primary::sparkling::CAVA",
              "primary::sparkling::PET NAT",
              "primary::sparkling::PROSECCO",
              "primary::sparkling::CHAMPAGNE",
              "primary::sparkling::OTHER BUBBLES"
          ]
      },
      "Rose": {
          "filterOptionId": "pf_t_rose",
          "prefix": "primary\\:\\:rosé\\:\\:",
          "manualValues": [
              "primary::rosé::CITRUS",
              "primary::rosé::FRUITY",
              "primary::rosé::FRESH AND CRISPY",
              "primary::rosé::HERBAL AND FLORAL",
              "primary::rosé::LIGHT AND MINERAL"
          ]
      },
      "White": {
          "filterOptionId": "pf_t_white",
          "prefix": "primary\\:\\:white\\:\\:",
          "manualValues": [
              "primary::white::AROMATIC AND FRUITY",
              "primary::white::Full bodied and Oaked",
              "primary::white::NATURAL AND ORANGE",
              "primary::white::Crispy and Mineral",
              "primary::white::Light and Fresh"
          ]
      },
      "Red": {
          "filterOptionId": "pf_t_red",
          "prefix": "primary\\:\\:red\\:\\:",
          "manualValues": [
              "primary::red::FRUITY",
              "primary::red::LIGHT BODIED",
              "primary::red::MEDIUM BODIED",
              "primary::red::ELEGANT AND ROUND",
              "primary::red::FULL BODIED AND OAKED",
              "primary::red::NATURAL"
          ]
      },
      "Sweet and fortified": {
          "filterOptionId": "pf_t_sweet_and_fortified",
          "prefix": "primary\\:\\:sweet and fortified\\:\\:",
          "manualValues": [
              "primary::sweet and fortified::Sweet",
              "primary::sweet and fortified::Fortified"
          ]
      },
      "Kosher": {
          "filterOptionId": "pf_t_kosher",
          "prefix": "primary\\:\\:kosher\\:\\:",
          "manualValues": [
              "primary::kosher::Kosher Red",
              "primary::kosher::Kosher White",
              "primary::kosher::Kosher Sparkling",
              "primary::kosher::Kosher Rose",
              "primary::kosher::Kosher Sweet and Fortified"
          ]
      },
      "Occasion": {
          "filterOptionId": "pf_t_occasion",
          "prefix": "primary\\:\\:occasion\\:\\:",
          "manualValues": [
              "primary::occasion::APÉRO",
              "primary::occasion::BRUNCH",
              "primary::occasion::NATURE",
              "primary::occasion::Friends",
              "primary::occasion::SHABBAT",
              "primary::occasion::CELEBRATION",
              "primary::occasion::A DATE NIGHT",
              "primary::occasion::CHAISE LONGUE",
              "primary::occasion::FAMILY DINNER",
              "primary::occasion::VYNIL LISTENING"
          ]
      },
      "Country": {
          "filterOptionId": "pf_t_country",
          "prefix": "primary\\:\\:country\\:\\:",
          "manualValues": [
              "primary::country::USA",
              "primary::country::Chile",
              "primary::country::Italy",
              "primary::country::Spain",
              "primary::country::France",
              "primary::country::Greece",
              "primary::country::Israel",
              "primary::country::Austria",
              "primary::country::Germany",
              "primary::country::Hungary",
              "primary::country::Portugal",
              "primary::country::Slovenia",
              "primary::country::Argentina",
              "primary::country::Australia",
              "primary::country::Macedonia",
              "primary::country::New Zealand",
              "primary::country::South Africa",
              "primary::country::Georgia",
              "primary::country::China",
              "primary::country::Morocco"
          ]
      },
      "Region": {
          "filterOptionId": "pf_t_region",
          "prefix": "primary\\:\\:region\\:\\:",
          "manualValues": null
      },
      "Grape": {
          "filterOptionId": "pf_t_grape",
          "prefix": "secondary\\:\\:grape\\:\\:",
          "manualValues": null
      },
      "Alcohol": {
          "filterOptionId": "pf_t_alcohol",
          "prefix": "secondary\\:\\:alcohol\\:\\:",
          "manualValues": null
      },
      "Sweetness": {
          "filterOptionId": "pf_t_sweetness",
          "prefix": "secondary\\:\\:sweetness\\:\\:",
          "manualValues": null
      },
      "Acidity": {
          "filterOptionId": "pf_t_acidity",
          "prefix": "secondary\\:\\:acidity\\:\\:",
          "manualValues": null
      },
      "Tannin": {
          "filterOptionId": "pf_t_tannin",
          "prefix": "secondary\\:\\:tannin\\:\\:",
          "manualValues": null
      },
      "Body": {
          "filterOptionId": "pf_t_body",
          "prefix": "secondary\\:\\:body\\:\\:",
          "manualValues": null
      },
      "Tag": {
          "filterOptionId": "pf_t_tag",
          "prefix": "secondary\\:\\:profile\\:\\:",
          "manualValues": null
      }
  };

  const state = {
    parent: null,
    preferences: {},
    products: [],
    cardReasons: null,
    filters: [],
    filterPrefix: '',
    isRegistered: true,
    isLandingPage: false,
    maxMatchingPoints: 0,
  };

  const relationType = {
    OR: 'or',
    DEFAULT: 'default',
  };

  return class PnKPreferencesClass {
    constructor({ parent }) {
      state.parent = parent;
      state.filterPrefix = 'pf_t_';
    }

    init() {
      window.addEventListener('DOMContentLoaded', async () => {
        state.isRegistered = window.Flits?.customer_id > 0;
        state.isLandingPage = document.querySelector(`.${PREFERENCE_ROOT_SELECTOR}`)?.dataset.type === 'landing';

        showLoader();

        await getPreferenceProducts();

        if (VERBOSE) console.time('update profile data');
        updateProfileData();
        if (VERBOSE) console.timeEnd('update profile data');

        if (VERBOSE) console.time('build cards');
        buildCards();
        if (VERBOSE) console.timeEnd('build cards');

        hideLoader();
      });
    }
  };

  function showLoader() {
    const root = document.querySelector(`.${PREFERENCE_ROOT_SELECTOR}`);
    const list = root?.querySelector(`.${PREFERENCE_LIST_SELECTOR}`);

    if (!list) return;

    list.classList.add('loading');
  }

  function hideLoader() {
    const root = document.querySelector(`.${PREFERENCE_ROOT_SELECTOR}`);
    const list = root?.querySelector(`.${PREFERENCE_LIST_SELECTOR}`);

    if (!list) return;

    list.classList.remove('loading');
  }

  function buildCards() {
    const root = document.querySelector(`.${PREFERENCE_ROOT_SELECTOR}`);
    const list = root?.querySelector(`.${PREFERENCE_LIST_SELECTOR}`);
    const template = root?.querySelector(`.${PREFERENCE_CARD_TEMPLATE_SELECTOR}`);

    if (!list || !template) return;

    if (state.cardReasons === null) {
      const source = root.querySelector('[data-quiz-card-reasons]');

      try {
        const parsed = JSON.parse(source?.textContent || '{}');
        state.cardReasons = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch (error) {
        console.error('Error parsing quiz-card metafields.', error);
        state.cardReasons = {};
      }
    }

    const buildCard = (product, index) => {
      const node = template.content?.cloneNode(true);

      if (!node) return;

      const anchor = node.querySelector('a');
      const imageWrapper = node.querySelector(`.${PREFERENCE_CARD_IMAGE_WRAPPER_SELECTOR}`);
      const productTitle = node.querySelector('h4');
      const match = node.querySelector(`.${PREFERENCE_CARD_MATCH_SELECTOR}`);
      const reason = node.querySelector(`.${PREFERENCE_CARD_REASON_SELECTOR}`);
      const priceNode = node.querySelector(`.${PREFERENCE_CARD_PRICE_SELECTOR}`);
      const aromaNode = node.querySelector(`.${PREFERENCE_CARD_AROMA_SELECTOR}`);
      const button = node.querySelector('button');

      if (anchor) {
        anchor.href = `${root.dataset.collectionUrl}/products/${product.handle}`;
        anchor.dataset.flitsProductId = product.handle;
        anchor.setAttribute('x-on:click.prevent.stop', `setAjaxProduct('${product.handle}')`);
      }

      if (imageWrapper)
      {
        state.parent.renderImage({
          parent: imageWrapper,
          src: product.images_info.length ? (product.images_info[0].src || boostPFSConfig.general.no_image_url) : boostPFSConfig.general.no_image_url,
          imgClassnames: 'w-full h-full object-cover',
          lazy: index >= FIRST_UNLAZY_IMAGES_COUNT,
          priority: 'high'
        });
      }

      if (productTitle) productTitle.textContent = product.title.replace('&#39;', '\'');

      if (match) match.textContent = match.textContent.replace('[match_percent]', `${product.matching}%`);

      if (reason) {
        const copy = String(state.cardReasons[String(product.id)] || '').trim();

        if (copy) {
          reason.textContent = copy;
          reason.hidden = false;
        } else {
          reason.hidden = true;
        }
      }

      if (priceNode) {
        const price = document.createElement('span');
        const priceFull = product.price_max > product.price_min ? document.createElement('span') : null;

        price.textContent = state.parent.toMoney(product.price_min);
        priceNode.append(price);

        if (priceFull) {
          priceFull.textContent = state.parent.toMoney(product.price_max);
          priceFull.classList.add('line-through', 'text-gray');
          priceNode.append(priceFull);
        }
      }

      if (button) {
        // Sets carry no stock of their own — availability comes from the
        // precomputed map (assets/bundle-availability.js).
        const purchasable = window.BundleAvailability
          ? window.BundleAvailability.isPurchasable(product)
          : product.available;

        if (purchasable || state.isLandingPage) {
          button.setAttribute("x-on:click.prevent.stop", `addToCart(${product.variants[0].id }, 1, {_isBundle: false})`);
          button.textContent = root.dataset.buttonAddToCart;
        } else {
          button.disabled = true;
          button.textContent = window.BundleAvailability
            ? window.BundleAvailability.unavailableLabel(product)
            : root.dataset.buttonSoldOut;
        }
      }
      

       // fill aroma
       if (aromaNode) {
        const aromas = product.tags.filter((tag) => tag.includes('::aroma::'))

        aromas.forEach((tag) => {
          const tagKey = state.parent.tagToKey(tag.split('::').splice(1).join('::'));
          const aroma = document.createElement('li');
          const aromaImageWrapper = document.createElement('div');

          state.parent.renderImage({
            parent: aromaImageWrapper,
            src: `${window.Shopify.cdnImagePath}${tagKey}.png`,
            imgClassnames: "w-full h-full object-cover",
            lazy: false,
          });

          aroma.classList.add(`${PREFERENCE_CARD_AROMA_SELECTOR}-item`);

          aroma.append(aromaImageWrapper);
          aromaNode.append(aroma);
        })
      }

      // CR-29 §5: expose filter/sort data on the card root so the client-side
      // filters can show/hide and reorder WITHOUT refetching or paging. Values
      // come from the product's primary::<group>:: tags + price/match/date.
      const cardRoot = node.querySelector('li') || node.firstElementChild;
      if (cardRoot) {
        const tagVals = (group) => (product.tags || [])
          .filter((t) => t.indexOf(`primary::${group}::`) === 0)
          .map((t) => t.split('::').slice(2).join('::').trim().toLowerCase())
          .join('|');
        // Type spans several primary groups (white/red/rosé/sparkling/...).
        const types = (product.tags || [])
          .filter((t) => /^primary::(white|red|ros[eé]|orange|sparkling|sweet and fortified)::/i.test(t))
          .map((t) => t.split('::')[1].trim().toLowerCase())
          .filter((v, i, a) => a.indexOf(v) === i)
          .join('|');
        cardRoot.classList.add('preference-card');
        cardRoot.dataset.filterType = types;
        cardRoot.dataset.filterCountry = tagVals('country');
        cardRoot.dataset.filterOccasion = tagVals('occasion');
        cardRoot.dataset.sortPrice = String(product.price_min || 0);
        cardRoot.dataset.sortMatch = String(product.matching || 0);
        cardRoot.dataset.sortDate = String(
          product.published_at || product.created_at || product.id || 0,
        );
        cardRoot.dataset.sortBest = String(product.orders_count || product.sold || 0);
      }

      list.append(node);
      // Cards are injected after Alpine has started, so Alpine never processes
      // the x-on:click that opens the product quick-view drawer — clicks then
      // fall through to the href and navigate away. Init the new card's subtree
      // so the drawer binding is attached.
      try { if (window.Alpine && Alpine.initTree && cardRoot) Alpine.initTree(cardRoot); } catch (e) {}
    };

    state.products.forEach(buildCard);

    // CR-29 §5: let the filters know the cards are (re)built.
    document.dispatchEvent(new CustomEvent('preferenceCards:built'));

    // smartMart:added experiment: send wine matches as Amplitude event
    document.dispatchEvent(new CustomEvent('tasteProfile:shown', {detail: state.products}));
  }

  function updateProfileData() {
    const basicsNode = document.querySelector(`.${PREFERENCE_BASICS_SELECTOR}`);
    const getBasics = (name) => {
      const { types } = state.preferences[name] || {};

      if (!types?.length) return null;

      return types[0];
    };

    // Fallback (client decision): when the visitor has NO value for a taste
    // basic — neither their own quiz answer nor a server-rendered metafield
    // (e.g. they disliked every option) — derive it from the first matched
    // (100%) wine's `secondary::<key>::N` tag so the row never renders empty.
    // N is a 0..5 level; map it to a localized Low/Medium/High word.
    const LEVELS = {
      de: ['Niedrig', 'Niedrig', 'Mittel', 'Mittel', 'Hoch', 'Hoch'],
      en: ['Low', 'Low', 'Medium', 'Medium', 'High', 'High'],
    };
    const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    const levelWords = LEVELS[lang] || LEVELS.en;
    const firstWine = Array.isArray(state.products) && state.products.length ? state.products[0] : null;
    const wineBasic = (name) => {
      if (!firstWine || !Array.isArray(firstWine.tags)) return null;
      const tag = firstWine.tags.find((t) => t.indexOf(`secondary::${name}::`) === 0);
      if (!tag) return null;
      const n = parseInt(tag.split('::')[2], 10);
      if (!Number.isFinite(n)) return null;
      return levelWords[Math.max(0, Math.min(levelWords.length - 1, n))];
    };
    // Only these three fall back to the wine; "body" stays quiz-only (hidden otherwise).
    const WINE_FALLBACK = new Set(['acidity', 'sweetness', 'tannin']);

    ['acidity', 'sweetness', 'tannin', 'body'].forEach((key) => {
      const liNode = basicsNode?.querySelector(`.${PREFERENCE_BASICS_SELECTOR}-${key}`);
      const valueNode = liNode?.querySelector(`.${PREFERENCE_BASICS_VALUE_SELECTOR}`);

      if (!valueNode) return;

      let value = getBasics(key);

      // A real metafield value already rendered server-side wins over the wine
      // fallback — just make sure the row is visible, never overwrite it.
      const existing = (valueNode.textContent || '').replace(/[\s\u00A0]/g, '');
      if (value == null && existing) {
        liNode.classList.remove('hidden');
        liNode.classList.add('appeared');
        return;
      }

      if (value == null && WINE_FALLBACK.has(key)) value = wineBasic(key);
      if (value == null) return;

      valueNode.textContent = value;
      liNode.classList.remove('hidden');
      liNode.classList.add('appeared');
    });

    showStoredUsername();
  }

  function showStoredUsername() {
    const greetings = document.querySelector(`.${PREFERENCE_GREETINGS_SELECTOR}`);
    const greetingsCaption = greetings?.querySelector('h2');
    const usernameNode = greetingsCaption?.querySelector('span');
    const storedUsername = restore('data.username');

    if (!usernameNode) return;

    if (storedUsername?.length > 0) usernameNode.textContent = ` ${storedUsername}`;

    if (!usernameNode.classList.contains('hidden')) return;

    usernameNode.classList.remove('hidden');
    usernameNode.classList.add('appeared');
  }

  async function getPreferenceProducts() {
    if (VERBOSE) console.log('getting preference products...');
    if (VERBOSE) console.time('get preference products');

    const limit = 24;
    const page = 1;
    const relation = relationType.OR;
    const root = document.querySelector(`.${PREFERENCE_ROOT_SELECTOR}`);
    const config = window.boostPFSConfig;
    const { collectionId } = root?.dataset || {};

    if (!root) return;

    if (!config) {
      console.error('Error! Can\'t find boost app config.');
      return null;
    }

    const url = new URL(config.api.filterUrl || '');
    const params = getQueryParams({ config, collectionId, limit, page });

    Object.entries(params).forEach(setParamTo(url));

    const actions = {
      [relationType.OR]: async () => {
        const fetchProductsBy = (requestUrl, id, values) =>
          fetchProducts(requestUrl).then((data) => {
            const pages = Math.floor(data.totalCount / limit) + 1;
            return { id, values, pages, products: data.products };
          });

        const requests = (!state.filters.length || state.isLandingPage)
          ? [fetchProductsBy(url)]
          : state.filters
              .map(async ({ id, values }) => {
                if (!values?.length) return;

                const filterGroupUrl = new URL(url.toString());

                values?.forEach((value) => {
                  filterGroupUrl.searchParams.append(id, value);
                });

                return fetchProductsBy(filterGroupUrl, id, values);
              });

        return Promise.all(requests).then(async (result) => {
          const fetches = [];
          const data = result.filter(Boolean);
          const products = data.reduce((acc, { products }) => ([...acc, ...(products || [])]), []);

          data.forEach(async ({ id, values, pages }) => {
            if (!values?.length || pages === 1) return;

            const filterGroupUrl = new URL(url.toString());

            values?.forEach((value) => {
              filterGroupUrl.searchParams.append(id, value);
            });

            for (let page = 2; page < pages + 1; page++) {
              filterGroupUrl.searchParams.set('page', page);
              fetches.push(fetchProducts(filterGroupUrl).then(({ products }) => products));
            }
          });

          (await Promise.all(fetches)).forEach((items) => products.push(...items));

          return products;
        })
      },
      [relationType.DEFAULT]: async () => {
        state.filters.forEach(({ id, values }) => {
          if (!values?.length) return;

          values?.forEach((value) => {
            url.searchParams.append(id, value);
          });
        });

        if (!url.search.length) return [];

        const { products } = await fetchProducts(url);

        return products;
      },
    };

    if (VERBOSE) console.time('get quiz data');
    state.preferences = await getPreferenceQuizData();
    if (VERBOSE) console.timeEnd('get quiz data');

    // Fill the taste basics (acidity/sweetness/tannin) from the quiz preferences
    // right away — before the slow Boost filters + product fetch below. The wine
    // fallback for any missing value is filled by the post-fetch call later.
    try { updateProfileData(); } catch (e) {}

    if (VERBOSE) console.time('get preference filters');
    state.filters = await getPreferenceFilters();
    if (VERBOSE) console.timeEnd('get preference filters');

    if (!restore('preferences')) {
      store('preferences', state.preferences);
    }

    if (VERBOSE) console.time('get all products');
    const allProducts = await actions[relation]();
    if (VERBOSE) console.timeEnd('get all products');

    const products = state.parent.compose(
      uniqProducts,
      filterSparkling,
      filterRedWhite,
      matchingProducts,
      sortingByMatching
    )(allProducts);

    // limit products for unregistered user or for landing page
    if (state.isLandingPage) {
      state.products = products.filter(product => product.matching >= LANDING_MIN_MATCHING_SCORE);
      if (state.products.length < LANDING_MIN_CARDS) {
        state.products = products.splice(0, LANDING_MIN_CARDS);
      }
    } else {
      state.products =
        state.isRegistered || !UNREGISTERED_USER_CARDS_LIMIT ? products : products.splice(0, UNREGISTERED_USER_CARDS_LIMIT);
    }

    if (VERBOSE) console.timeEnd('get preference products');
  }

  function sortingByMatching(products) {
    if (VERBOSE) console.time('sorting products by matching');
    const result = products.sort((first, second) => second.matching - first.matching);
    if (VERBOSE) console.timeEnd('sorting products by matching');
    return result;
  }

  function matchingProducts(products) {
    if (VERBOSE) console.time('matching products')
    const getUnionGroup = (group) => {
      return Object.keys(unionMatchingFilterGroups).reduce((accGroups, key) => {
        if (accGroups)
          return accGroups;

        if (unionMatchingFilterGroups[key].includes(group))
          return key;

        return accGroups;
      }, null);
    };

    const filters = state.filters.reduce((acc, { name, values, valuable }) => {
      const group = getUnionGroup(name);

      if (group)
        return {
          ...acc,
          [group]: {
            values: [...(acc[group] && acc[group].values || []), ...values],
            valuable: (acc[group] && acc[group].valuable || 0) + valuable,
            count: (acc[group] && acc[group].count || 0) + 1,
          },
        };

      return {
        ...acc,
        [name]: {
          values,
          valuable,
        },
      };
    }, {});

    Object.keys(filters).forEach((key) => {
      if (!filters[key].count) return;

      filters[key] = {
          values: filters[key].values,
          valuable: filters[key].valuable / filters[key].count,
      };
    }, {});

    products.forEach((product) => {
      let hasProfileTag = false;
      if (VERBOSE) console.log('[Matching] Calculating match for', product.title, product.tags);
      const groupPoints = product.tags.reduce((acc, tag) => {
        const tagParts = tag.split('::');
if (tagParts.length < 2) return acc; // пропускаем этот тег
const tagGroup = tagParts[1];
      

        const unionGroup = getUnionGroup(tagGroup);
        const group = unionGroup || tagGroup;
       const valuable = (filters[group] || (unionGroup ? state.preferences.white : {}))?.valuable;


        if (valuable && !acc[group]) {
          if (VERBOSE) console.log(`[Matching] -- [max] ${group}: ${valuable} (${tag})`);
          return { ...acc, [group]: valuable };
        }

        return acc;
      }, {});

      const points = product.tags.reduce((acc, tag) => {
        const tagParts = tag.split('::');
        if (tagParts.length < 2) return acc; // пропускаем этот тег
        const tagGroup = tagParts[1];
        const unionGroup = getUnionGroup(tagGroup);
        const group = unionGroup || tagGroup;
        let filterObj = filters[group] || (unionGroup ? state.preferences.white : {}) || {};
let { values, valuable } = filterObj;

        const isProfileTag = group === 'profile';
        if (VERBOSE) {
        console.log(`[DEBUG] tag: ${tag}`);
        console.log(`[DEBUG] group: ${group}`);
        console.log(`[DEBUG] values:`, values);
      }
        const isMatching = (() => (unionGroup || !!values?.includes(tag)))();

        if (isMatching && isProfileTag) {
          valuable *= hasProfileTag ? 5 / 60 : 55 / 60;

          if (!hasProfileTag)
            hasProfileTag = true;
        }
        if (isMatching) {
          if (VERBOSE) console.log(`[Matching] -- ${group}: ${valuable} (${tag})`);
        }

        return isMatching ? acc + valuable : acc;
      }, 0);

        const maxPoints = Object.values(groupPoints).reduce((acc, value) => acc + value, 0);
  if (VERBOSE) console.log(`[Matching] -- maxPoints: ${maxPoints}`);
  if (VERBOSE) console.log(`[Matching] -- points: ${points}`);

  if (state.maxMatchingPoints < maxPoints) {
    state.maxMatchingPoints = maxPoints;
  }

  product.points = points;
    });

    products.forEach((product, index) => {
  if (index < 9) {
    product.matching = 100;
  } else if (index < 9 + 5) { // с 7 по 11 включительно
    product.matching = 95;
  } else if (index < 9 + 5 + 4) { // с 7 по 11 включительно
    product.matching = 90;
  } else if (index < 9 + 5 + 4 + 4) { // с 12 по 15 включительно
    product.matching = 80;
  } else {
    product.matching = 75;
  }
});

    return products;
  }

  function filterRedWhite(products) {
    if (VERBOSE) console.time('filterize red-white');
    const counts = { red: 0, white: 0 };
    const filteredCounts = { red: 0, white: 0 };
    const whitePercent = Number(!!state.preferences.white?.values?.length && state.preferences.white.values[0]);

    const ableTags = (tags) => {
      const result = { red: false, white: false };

      tags.forEach((tag) => {
        if (!result.white && tag.toLowerCase().includes('white')) result.white = true;
        else if (!result.red && tag.toLowerCase().includes('red')) result.red = true;
      });

      return result;
    };

    const getRedWhiteCount = () => {
      products.forEach(({ tags }) => {
        const able = ableTags(tags);

        if (able.red) counts.red++;
        if (able.white) counts.white++;
      });
    };

    getRedWhiteCount();

    filteredCounts.white = Math.round((counts.white * whitePercent) / 100);
    filteredCounts.red = Math.round((counts.red * (100 - whitePercent)) / 100);

    counts.red = 0;
    counts.white = 0;

    const result = products.filter((product) => {
      const { red, white } = ableTags(product.tags);

      if (red) {
        counts.red++;

        if (counts.red > filteredCounts.red) return false;
      }

      if (white) {
        counts.white++;

        if (counts.white > filteredCounts.white) return false;
      }

      return true;
    });
    if (VERBOSE) console.timeEnd('filterize red-white');

    return result;
  }

  function filterSparkling(products) {
    if (VERBOSE) console.time('filterize sparkling');
    const isExcludeSparkling =
      Number(!!state.preferences.sparkling?.values?.length && state.preferences.sparkling.values[0]) === 0;
    const result = isExcludeSparkling
      ? products.filter(({ tags }) => !tags.reduce((acc, tag) => acc || tag.toLowerCase().includes("sparkling"), false))
      : products;
    if (VERBOSE) console.timeEnd('filterize sparkling');

    return result;
  }

  async function getPreferenceQuizData() {
    const { preferences, result } = restore() || {};

    if (preferences && Object.keys(preferences).length > 0)
      return preferences;

    // Cross-browser restore: raw_answers + categories saved to localStorage on quiz completion,
    // re-calculate preferences client-side using quiz controller
    if (result && Object.keys(result).length > 0) {
      try {
        const { categories } = restore() || {};
        const recalculated = window.pnk?.quizController?.definePreferences(result, categories);
        if (recalculated && Object.keys(recalculated).length > 0) {
          store('preferences', recalculated);
          return recalculated;
        }
      } catch (e) {}
    }

    try {
      return await window.Flits?.getCustomFieldsData().then(({ wine_preferences }) => {
        return JSON.parse(wine_preferences || '{}').preferences || {};
      });
    } catch {
      console.error(
        'Error get preferences data from server. Perhaps you must be a registered. Preferences data restore from a local storage'
      );
      return preferences;
    }
  }

  async function getPreferenceFilters() {
    const excludeTags = ['white'];

    const uniq = (arr) => arr.reduce((a, v) => (a.includes(v) ? a : [...a, v]), []);
    const capitalize = (text) => `${text[0].toUpperCase()}${text.slice(1)}`;

    const mergeFilters = (acc, { id, name, values, valuable }) => {
      if (!id) return acc;

      if (!acc[id])
        return {
          ...acc,
          [id]: {
            id,
            name,
            values,
            valuables: [valuable],
          },
        };

      return {
        ...acc,
        [id]: {
          id,
          name,
          values: uniq([...acc[id].values, ...values]),
          valuables: [...acc[id].valuables, valuable],
        },
      };
    };

    const boostOptions = await state.parent.getRootScopeData('boostPFS.filter.data.filter.options');
    let options = (boostOptions || []).reduce((acc, { label, filterOptionId, prefix, manualValues }) => {
      return {
        ...acc,
        [label]: { filterOptionId, prefix, manualValues },
      };
    }, {});
    if (!options.length) {
      options = fallbackOptions;
    }
    const groupedFilters = Object.keys(state.preferences)
      .map((tag) => {
        const { values: preferenceValues, valuable, types } = state.preferences[tag] || {};
        const option = options[capitalize(tag)];
        const isProfileTag = tag.startsWith('profile_');
        const needSkip = types?.includes('none') || excludeTags.includes(tag);

        if (needSkip) return null;

        if (isProfileTag)
          return {
            id: `${state.filterPrefix}profile[]`,
            name: 'profile',
            values: preferenceValues?.map((value) => `secondary::profile::${value}`),
            valuable,
          };

        if (!option) return null;

        const { filterOptionId, prefix } = option;
        const tagPrefix = prefix?.replace(/\\/g, '') || '';
        const manualValues = [...(option.manualValues || [])];
        const typedValues = {
          all: manualValues,
          default: preferenceValues?.map((v) => {
            const tag = `${tagPrefix}${v}`;
            const value = [...manualValues.filter((manual) => manual.toLowerCase() === tag.toLowerCase()), tag][0];

            return value;
          })
          .filter(Boolean),
        };
        const values = types?.map((type) => typedValues[type] || typedValues.default)[0];

        return {
          id: `${filterOptionId}[]`,
          name: tag,
          values,
          valuable,
        };
      })
      .filter(Boolean)
      .reduce(mergeFilters, {});

    const filters = Object.values(groupedFilters).map(({ id, name, values, valuables }) => ({
      id,
      name,
      values,
      valuable: valuables.reduce((a, v) => a + v, 0) / valuables.length,
    }));

    return filters;
  }

  function uniqProducts(products) {
    if (VERBOSE) console.time('uniquelize products');
    const flat = products.reduce((acc, group) => {
      const isGroup = Array.isArray(group);

      return [...acc, ...(isGroup ? group : [group])];
    }, []);
    const result = flat
      .reduce((acc, product) => {
        const hasProduct = Boolean(acc.filter((p) => p?.id === product?.id).length);

        return hasProduct ? acc : [...acc, product];
      }, [])
      .filter(Boolean);
    if (VERBOSE) console.timeEnd('uniquelize products');

    return result;
  }

  async function fetchProducts(url) {
    const result = fetch(url).then(async (response) => {
      if (!response.ok) {
        console.error(`Error fetching boost filtered data. ${response.statusText}`);
        return { products: [], total_product: 0 };
      }

      const data = await response.text();
      const json = parseBoostPayload(`${data.replace(/'/g, '&#39;')}`);
      const { products = [], total_product = 0 } = json;

      return { products, totalCount: total_product };
    });

    return result;
  }

  // Boost rewrites these requests to its SSR endpoint, and that endpoint answers
  // 502 "Invalid FE API response" to anything asking for a JSONP wrapper. Plain
  // JSON is served by both the old and the new one, so the wrapper is no longer
  // requested; it is still unwrapped here in case a cached response arrives in
  // the old shape.
  function parseBoostPayload(text) {
    const marker = 'BoostPFSFilterCallback(';
    const body = text.indexOf(marker) > -1
      ? text.slice(text.indexOf(marker) + marker.length).replace(/\)\s*;?\s*$/, '')
      : text;
    try {
      return JSON.parse(body) || {};
    } catch (e) {
      console.error('Boost: unreadable filter response', e);
      return {};
    }
  }

  function setParamTo(url) {
    if (!url?.searchParams) return () => {};
    return ([k, v]) => url.searchParams.set(k, v);
  }

  function getQueryParams({ config, collectionId, limit, page }) {
    return {
      t: Date.now(),
      _: 'pf',
      shop: config.shop.domain,
      page,
      limit,
      sort: 'manual',
      display: 'grid',
      collection_scope: collectionId,
      tag: '',
      product_available: false,
      variant_available: false,
      zero_options: true,
      build_filter_tree: false,
      check_cache: true,
      locale: config.general.current_locale,
      event_type: 'filter',
    };
  }

  function store(key, value) {
    if (state.isLandingPage) {
      state.parent.store('landing', `quiz.${key}`, value)
    } else {
      state.parent.store('quiz', key, value);
    }
  }

  function restore(key) {
    return state.isLandingPage
      ? state.parent.restore('landing', key ? `quiz.${key}` : 'quiz')
      : state.parent.restore('quiz', key);
  }
}();
